export default class Accordions {
	constructor(accordionParent, accordionItems, limitToOneOpen = false) {
		this.accordionParent = accordionParent
		this.accordionItems = accordionItems
		this.limitToOne = limitToOneOpen

		this.getDomElements()

		if (!this.dom.parent || !this.dom.accordions.length) return

		this.accordions = []
		this.init()
	}


	init() {
		this.setAccordions()
		this.handleClick()
		this.handleResize()
	}


	handleClick() {
		this.accordions.forEach(accordion => {
			accordion.trigger.addEventListener('click', () => {
				if (this.limitToOne && !accordion.active) {
					this.handleCloseAccordions(accordion.index)
				}

				accordion.trigger.classList.toggle('is-active')
				accordion.trigger.querySelector('ion-icon').classList.toggle('is-active')
				accordion.content.style.height = accordion.active ? '0px' : `${accordion.height}px`
				accordion.active = !accordion.active
			})
		})
	}


	handleCloseAccordions(index) {
		this.accordions.forEach(accordion => {
			if (accordion.index == index) return

			accordion.content.style.height = '0px'
			accordion.trigger.classList.remove('is-active')
			accordion.trigger.querySelector('ion-icon').classList.remove('is-active')
			accordion.active = false
		})
	}


	handleResize() {
		window.addEventListener('resize', () => {
			this.setAccordionHeights()
		})
	}


	setAccordions() {
		this.dom.accordions.forEach((accordion, index) => {
			let accordionObject = {
				index: index,
				element: accordion,
				trigger: accordion.querySelector('[data-trigger]'),
				content: accordion.querySelector('[data-content]'),
				height: 0,
				active: false
			}


			if (accordionObject.trigger && accordionObject.content) {
				this.accordions.push(accordionObject)
			}
		})

		this.setAccordionHeights()
	}


	setAccordionHeights() {
		this.accordions.forEach(accordion => {
			accordion.content.style.height = 'auto'
			accordion.height = accordion.content.scrollHeight
			accordion.content.style.height = accordion.active ? `${accordion.height}px` : '0px'
		})
	}


	getDomElements() {
		this.dom = {
			parent: this.accordionParent,
			accordions: this.accordionParent.querySelectorAll(this.accordionItems)
		}
	}
}
